import React from 'react';

import { jobPostingUrl, jobPostAppsUrl, profileUrl } from 'buyside/util/urlHelper';

import styles from './jobVaultShowFooterBlockStyles.scss';

const JobVaultShowFooterBlock = ({
  jobPostId,
  profileId,
  canApplyToJobs,
  isAuthor,
  disqualifiedReasons
}) => {
  if (isAuthor)
    return (
      <div className={styles.container}>
        <div className={styles.title}>You are the author of this job posting</div>
        <div className={styles.subtitle}>From here you can: </div>
        <ul>
          <li>
            <a className={styles.link} href={jobPostingUrl()}>
              View Your Job Postings
            </a>
          </li>
          <li>
            <a className={styles.link} href={jobPostAppsUrl(jobPostId)}>
              View Applications For This Position
            </a>
          </li>
        </ul>
      </div>
    );

  if (canApplyToJobs && disqualifiedReasons.length)
    return (
      <div id="reasons" className={styles.container}>
        <div className={styles.title}>Job Requirements Not Met</div>
        <div className={styles.subtitle}>
          You do not satisfy the following requirement{disqualifiedReasons.length > 1 ? 's ' : ' '}
          for this position:
        </div>
        <ul>
          {disqualifiedReasons.map(reason => (
            <li key={reason}>{reason}</li>
          ))}
        </ul>
        <span>
          Please{' '}
          <a className={styles.link} href={profileUrl(profileId)}>
            review your SumZero profile
          </a>{' '}
          to ensure it reflects the most up-to-date information about your qualifications.
        </span>
      </div>
    );

  return null;
};

export default JobVaultShowFooterBlock;
